import { jsx } from "react/jsx-runtime";
import { ErrorMessageWrapper, ErrorAppearance } from "@wix/wix-ui-tpa/cssVars";
import { getErrorDataHook } from "../../services/field-attributes.js";
import { classes } from "./field-error-wut.st.css";
const FieldErrorWUT = ({
  target,
  hasError,
  errorMessage,
  id
}) => {
  return /* @__PURE__ */ jsx(
    ErrorMessageWrapper,
    {
      className: classes.root,
      visible: Boolean(hasError),
      message: errorMessage ?? "",
      "data-hook": getErrorDataHook(target),
      messageId: id,
      errorAppearance: ErrorAppearance.TextOnly
    }
  );
};
export {
  FieldErrorWUT
};
//# sourceMappingURL=field-error-wut.js.map
